// Chinese (Simplified) (`zh-CN`) shell baseline
import { layoutZhCN } from './zh-CN/layout'
import { homeZhCN } from './zh-CN/home'
import { playZhCN } from './zh-CN/play'
import { demoZhCN } from './zh-CN/demo'
import { booksZhCN } from './zh-CN/books'
import { commerceZhCN } from './zh-CN/commerce'
import { communityZhCN } from './zh-CN/community'
import { dashboardZhCN } from './zh-CN/dashboard'
import { authZhCN } from './zh-CN/auth'
import { marketingZhCN } from './zh-CN/marketing'
import { worldZhCN } from './zh-CN/world'
import { encyclopediaZhCN } from './zh-CN/encyclopedia'
import { systemZhCN } from './zh-CN/system'
import { cityZhCN } from './zh-CN/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const baseZhCN: MessageCatalog = {
  ...layoutZhCN,
  ...homeZhCN,
  ...playZhCN,
  ...demoZhCN,
  ...booksZhCN,
  ...commerceZhCN,
  ...communityZhCN,
  ...dashboardZhCN,
  ...authZhCN,
  ...marketingZhCN,
  ...worldZhCN,
  ...encyclopediaZhCN,
  ...systemZhCN,
  ...cityZhCN,
}
